import * as React from 'react'
import { BProgress } from '@prague-digi/ui-components'
import { FormattedHTMLMessage } from 'react-intl'

import { helpers } from '../../utils'

interface Props {
  /** max value */
  max: number
  /** message @todo fix typo */
  message: any
  /** min value */
  min: number
  /** value */
  value: number
}

export const ProgressLine = ({ max, message, min, value }: Props) => {
  const progress = helpers.getPercentageFromValue(min, max, Number.EPSILON, value)

  return (
    <>
      <BProgress min={min} max={max} value={value} />
      <FormattedHTMLMessage
        {...message}
        values={{
          progress: helpers.numberToPercent(progress * 100),
        }}
      />
    </>
  )
}

export default ProgressLine
